import React, { useState } from "react";
import styles from "./curd.module.scss";
import {
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoText,
  KoTextArea,
  KoToast,
  Upload
} from "packages";
import ImgCrop from "antd-img-crop";
import KoIcon from "@kwapio/icons";
import { getCookie } from "shared/utils/cookies";

export default function AddCustomer({ form, handleSubmit }) {
  const [loading, setLoading] = useState(false);
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      KoToast.error("You can only upload JPG/PNG file!");
      setLoading(false);
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      KoToast.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const TextArea = ({ value, onChange }) => (
    <KoTextArea value={value} onChange={onChange} showCount
      maxLength={100}/>
  );


  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: null,
    colon: true,

    fields: [
      {
        key: "name",
        label: "Name",
        placeholder: " Type customer name here. . . ",
        colSpan: 4,
        rules: [
          {
            required: true,
            message: "Name is required"
          }
        ]
      },
      {
        key: "email",
        label: "Email",
        placeholder: " Type email here. . . ",
        colSpan: 4,
        rules: [
          {
            required: true,
            message: "email is required"
          }
        ]
      },
      {
        key: "phone",
        label: "Phone Number",
        placeholder: " Type phone number here. . . ",
        colSpan: 4,
        widget: 'number',
        rules: [
          {
            required: true,
            message: "Number is required"
          }
        ]
      },
      {
        key: 'shipping', label: 'Shipping ADDRESS', placeholder: 'Type product description here. . .', colSpan: 4,  widget: TextArea
      }
    ]
  };

  const props = {
    name: "files",
    multiple: true,
    accept: "image/*,video/*",
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: {
      service: getCookie("wos"),
      module: "taskplanner",
      lookupId: "lookupId"
    },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },

    onChange(info) {
      setLoading(true);
      if (info.file.status !== "uploading") {
      }
      const { fileList } = info;

      // Check if all uploads have either completed or failed
      const allFinished = fileList.every(
        (file) => file.status === "done" || file.status === "error"
      );

      if (allFinished) {
        setLoading(true);

        const successfulFiles = fileList
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            type: file.type,
            size: file.size,
            uid: file.uid,
            lastModifiedDate: file.lastModifiedDate || new Date().toISOString()
          }));

        console.log("successfulFiles", successfulFiles);
      } else if (info.file.status === "error") {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const uploadButton = (
    <div className={styles.dndArea}>
      {loading && <KoLoader size="small" />}
      <KoIcon name="ImagesOutlined" width={40} height={40}/>
      <KoText className={styles.fileInfo} text='At least 115px x 30px PNG or JPG file'/>
    </div>
  );


  return (
    <div className={styles.wrapper}>
      {loading && <KoLoader />}
      <div className={`${styles.formWrapper}`}>
        <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
          <KoForm.Item
            name={["Logo"]}
            valuePropName={["Logo"]}
            getValueFromEvent={normFile}
          >
            <ImgCrop
              aspect={115 / 25}
              cropShape="rect"
              restrictPosition
              showGrid={false}
              cropperProps={{
                cropSize: { width: 115, height: 25 },
                zoomWithScroll: false,
                showGrid: false,
                style: { pointerEvents: "none" }
              }}
            >
              <Upload
                {...props}
                accept=".png, .jpg, .jpeg"
                className={styles.upload}
                beforeUpload={beforeUpload}
                max={{ count: 1 }}
                showUploadList={false}
                showPreviewIcon={false}
                listType="picture-card"
              >
                {uploadButton}
              </Upload>
            </ImgCrop>
          </KoForm.Item>
          <div style={{ marginTop: '2rem' }}></div>
          <KoFormBuilder form={form} meta={meta} />
        </KoForm>
      </div>
    </div>
    
  );
}
